import { useMemo } from "react";
import { useWindowSize } from "./useWindowSize";
import { breakpoints } from "src/utils/css-constants";

const findBreakpoint = (width: number) =>
  Object.values(breakpoints).find(({ min, max }) => width >= min && width <= max);

export const useBreakpoint = () => {
  const { innerWidth } = useWindowSize();
  const breakpoint = useMemo(() => findBreakpoint(innerWidth), [innerWidth]);

  if (!breakpoint) {
    return "md";
  }

  return breakpoint.name || "md";
};

export const isMobile = (breakpoint: string) => breakpoint === "xs" || breakpoint === "sm";

export const useIsMobile = () => {
  const breakpoint = useBreakpoint();
  return breakpoint === "xs" || breakpoint === "sm";
};
